var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", [
    _c("div", { staticClass: "container-fluid" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-center flex-wrap",
        },
        [
          _c("div", { staticClass: "site_logo" }, [
            _c(
              "h1",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "navbar-brand",
                    attrs: { to: "/teacher-dashboard" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.Lang.get("messages.site_name")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "site_setting" }, [
            _c("ul", { staticClass: "navbar setting-list" }, [
              _c("li", { staticClass: "nav-item" }, [
                _c("div", { staticClass: "lang-blk" }, [
                  _vm.Lang.getLocale() == "ar"
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-link d-flex align-items-center border-left border-right-0",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.setLocale("en")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-globe mx-2" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("En")]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.Lang.getLocale() == "en"
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-link d-flex align-items-center border-right",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.setLocale("ar")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-globe mx-2" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("AR")]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.isTeacher || _vm.isHodAsTeacher
                ? _c("li", { staticClass: "nav-item notification dropdown" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link",
                        attrs: {
                          href: "#",
                          role: "button",
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false",
                        },
                      },
                      [
                        _c("i", { staticClass: "fab fa-facebook-messenger" }),
                        _vm._v(" "),
                        _vm.isTeacher && _vm.notifications.length
                          ? _c("span", { staticClass: "badge" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.notifications.length) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-menu",
                        attrs: { "aria-labelledby": "navbarDropdown" },
                      },
                      [
                        _vm.isTeacher
                          ? [
                              _vm._l(
                                _vm.notifications,
                                function (notification, index) {
                                  return _c(
                                    "router-link",
                                    {
                                      key: index,
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        to: {
                                          name: "messenger",
                                          params: {
                                            class_id: _vm._.get(
                                              _vm.getParentClass(
                                                notification.sender.classes
                                              ),
                                              "id"
                                            ),
                                            user_id: notification.sender.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "(" +
                                            _vm._s(
                                              _vm._.get(
                                                _vm.getParentClass(
                                                  notification.sender.classes
                                                ),
                                                "name"
                                              )
                                            ) +
                                            ")"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.Lang.get(
                                              "messages.new_message_from"
                                            )
                                          ) +
                                          "\n                  " +
                                          _vm._s(
                                            notification.sender?.parent?.name
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.notifications.length
                                ? _c("div", { staticClass: "dropdown-divider" })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "dropdown-item",
                            attrs: { to: { name: "messenger" } },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.Lang.get("messages.open_messenger")
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item dropdown" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link dropdown-toggle",
                    attrs: {
                      href: "#",
                      id: "navbarDropdown",
                      role: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.user.name) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    attrs: { "aria-labelledby": "navbarDropdown" },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "dropdown-item",
                        attrs: { to: "profile" },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.Lang.get("messages.profile")) +
                            "\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.logout.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.Lang.get("messages.logout")) +
                            "\n                "
                        ),
                        _c("i", {
                          staticClass:
                            "fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.isHodAsTeacher
                ? _c("li", { staticClass: "nav-item btn btn-warning btn-sm" }, [
                    _c("a", { on: { click: _vm.backToHOD } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.Lang.get("messages.back_to_HOD_dashboard")
                          ) +
                          "\n            "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }